export default {
  layoutShift: 'kazenmaier-layout-shift',
  leasingOfferData: 'kazenmaier-lo-data',
};
